export default __webpack_public_path__ + "static/media/email-active.b1e66252.svg";